import Service, { service } from '@ember/service';
import type FetchService from '@triptyk/ember-utils/services/fetch';
import type FlashMessageService from 'ember-cli-flash/services/flash-messages';
import type IntlService from 'ember-intl/services/intl';
import { RecontactFormChangeset } from 'frontend/changesets/recontact-form';
import type CurrentUserService from '../current-user';

export default class RecontactFormChangesetService extends Service {
  @service declare fetch: FetchService;
  @service declare flashMessages: FlashMessageService;
  @service declare intl: IntlService;
  @service declare currentUser: CurrentUserService;
  /* jscpd:ignore-start */
  async sendRecontactForm(changeset: RecontactFormChangeset) {
    changeset.execute();
    const changesetData = changeset.data;

    const body = {
      type: changesetData.type,
      name: changesetData.name,
      firstName: changesetData.firstName,
      lastName: changesetData.lastName,
      message: changesetData.message,
      email: changesetData.email,
      targetAudience: changesetData.targetAudience,
      phone: changesetData.phone,
    };

    try {
      await this.fetch.request('contact/recontact', {
        method: 'POST',
        body: JSON.stringify(body),
      });
      this.flashMessages.success(
        this.intl.t('components.modals.exit-modal.success_message')
      );
    } catch (e) {
      this.flashMessages.alert(
        this.intl.t('components.modals.exit-modal.fail_message')
      );
    }
  }
  /* jscpd:ignore-end */
  emptyChangeset() {
    const user = this.currentUser.user;
    return new RecontactFormChangeset({
      type: '',
      name: '',
      email: user?.email ?? '',
      firstName: user?.firstName ?? '',
      lastName: user?.lastName ?? '',
      message: '',
      phone: user?.phone ?? '',
      targetAudience: undefined,
    });
  }
}

declare module '@ember/service' {
  interface Registry {
    'changesets/recontact-form': RecontactFormChangesetService;
  }
}
